<template>
    <div class="page">
        <div class="page-header">
            <div class="header">
                <div class="header-left">品越建站管理系统</div><div class="header-right"><span>{{user.phone_mob}}</span><span @click="logout" class="logout">退出</span></div>
            </div>
        </div>
        <div class="page-content">
            <h2>所有站点</h2>
            <ul class="site-list">
                <li v-for="(site,index) in siteList" :key="index" class="list-li" :class="{'list-li-margin':(index+1)%3 != 0}">
                    <router-link :to="'/home?siteId='+site.id" class="li-a">
                        <div class="site-title">{{site.site_name}}</div>
                        <div class="expire-time">免费版</div>
                    </router-link>
                </li>
                <li class="list-li" :style="(siteCount+1) % 3 == 0?'margin-right:0':'margin-right:20px;'">
                    <div class="add-site" @click="showAddSite"><i class="iconfont icon-icon_add"></i>创建站点</div>
                </li>

            </ul>
            <el-dialog title="创建站点" :visible.sync="dialogFormVisible">
                <el-form :model="form">
                    <el-form-item label="站点名称" :label-width="formLabelWidth">
                        <el-input v-model="form.site_name" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addSite">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import Cookies from 'js-cookie'
    export default {
        name: "multiple",
        components: {
        },
        data(){
            return {
                user:{},
                siteList:[],
                dialogFormVisible:false,
                form:{},
                formLabelWidth:'120px',
                siteCount:0
            }
        },
        created() {
            this.userId = Cookies.get('user_id');
            this.$http.get('/v1/user/view',{params:{userId:this.userId}}).then((res)=>{
                this.user = res.data;
            })
            this.$http.get('/v1/sites/index',{params:{userId:this.userId}}).then((res)=>{
                if (res.data.errcode == 0) {
                    this.siteList = res.data.siteList;
                    this.siteCount = this.siteList.length;
                    console.log(this.siteCount)
                }
            })
        },
        mounted() {
            document.querySelector('body').setAttribute('style', 'background-color:#f5f7fa')
        },
        methods:{
            logout(){
                Cookies.remove('user_id');
                Cookies.remove('access_token');
                this.$router.push('/admin/login')
            },
            showAddSite(){
                this.dialogFormVisible = true;
            },
            addSite(){
                this.form.user_id = Cookies.get('user_id');
                this.$http.post('/v1/sites/create',this.form).then((res)=>{
                    if (res.data.errcode == 0) {
                        this.siteList = res.data;
                        this.dialogFormVisible = false;
                    }
                })
            }
        }
    }
</script>

<style scoped>
    body{
        background: #f5f7fa;
    }
    .header{
        width: 1000px;
        margin: 0 auto;
        height: 60px;
        line-height: 60px;
    }
    .page-header{
        background: #fff;
        width: 100%;
    }
    .header-left{
        font-size: 16px;
        float: left;
        font-weight: 600;
    }
    .header-right{
        float: right;
    }
    .logout{
        margin:0 0 0 20px;
        color: #2a75ed;
    }
    .page-content{
        width: 1000px;
        margin:20px auto;
      background: none;
    }
    .page-content h2{
        color: #353535;
        font-size: 14px;
        font-weight: 600;
    }
    .site-list{
        margin:10px 0 0 0;
      overflow:hidden;
      padding: 0;
    }
    .site-list li{
      list-style-type: none;
    }
    .list-li{
        width: 280px;
        background: #fff;
        height: 100px;
        cursor: pointer;
        float: left;
        margin-top: 20px;
        border-left-color: #2a75ed;
        padding:20px;
    }
    .list-li-margin{
        margin-right: 20px;
    }
    .li-a{
        display: block;
        overflow: hidden;
    }
    .add-site{
        text-align: center;
        color: #2a75ed;
        line-height: 100px;
    }
    .icon-icon_add{
        margin: 0 5px 0 0;
    }
    .site-title{
        font-size: 16px;
    }
    .expire-time{
        font-size: 12px;
        color: #888;
        margin:20px 0 0 0;
    }
</style>
